import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { MenuItems } from '../enums/menu-items.enum';
import { selectAuthorizationRecord } from '../store/authSlice';
import { hasUserMenuAccess } from '../utils/has-user-menu-access.util';

const ProtectedRoute: React.FC<{ menuName: MenuItems; children: any }> = ({ menuName, children }) => {
  const authorizationRecord = useSelector(selectAuthorizationRecord);

  if (!hasUserMenuAccess(menuName, authorizationRecord)) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
